<template>
  <!-- PP team expects to switch gallery implementation to ProductDetailPageGallery in the near future, whatever the "automated reviews" flag status. -->
  <ProductDetailPageGallery
    v-if="productResponse && isAutomatedReviewsInCarouselEnabled"
    :are-reviews-pending
    :images="productResponse.images"
    :product-type="productResponse.type"
    :reviews-from-product="reviewsFromProductResponse ?? undefined"
    :tracking-product-model="productResponse.model ?? ''"
    @sticker-click="handleStickerClick"
  >
    <template #sticker="{ size }">
      <slot name="sticker" :size />
    </template>
  </ProductDetailPageGallery>
  <!-- Keep GalleryNew for JP as long as 'step by step' A/B test is running. Later APAC team will switch to ProductDetailPageGallery (APAC-1203). -->
  <GalleryNew
    v-else-if="productResponse"
    :images="productResponse.images"
    :product-type="productResponse.type"
    :review="reviewInCarouselResponse ?? undefined"
    should-preload-first-img
    :tracking-product-model="productResponse.model ?? ''"
    @sticker-click="handleStickerClick"
  >
    <template #sticker="{ size }">
      <slot name="sticker" :size />
    </template>
  </GalleryNew>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { openModal } from '@ds/components/ModalBase'

import GalleryNew from '~/scopes/product-core/components/presentationals/GalleryNew/GalleryNew.vue'
import ProductDetailPageGallery from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/ProductDetailPageGallery.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { MODAL_NAMES } from '~/scopes/product-core/constants'

import { useFetchAutomatedReviewsForCarousel } from './composables/useFetchAutomatedReviewsForCarousel/useFetchAutomatedReviewsForCarousel'
import { useFetchReviewInGalleryNew } from './composables/useFetchReviewInGalleryNew/useFetchReviewInGalleryNew'

const { data: productResponse } = useFetchProduct()
const { data: reviewInCarouselResponse } = useFetchReviewInGalleryNew()
const { data: reviewsFromProductResponse, pending: areReviewsPending } =
  useFetchAutomatedReviewsForCarousel()
const experiments = useExperiments()
const { trackClick } = useTracking()

const isAutomatedReviewsInCarouselEnabled = computed(
  () =>
    experiments['experiment.ppAutomatedReviewsInCarousel'] ===
    'withAutomatedReviews',
)

function handleStickerClick() {
  openModal(MODAL_NAMES.VERIFIED_REFURBISHED)
  trackClick({
    zone: 'verified_refurbished_sticker',
    name: 'verified_refurbished',
  })
}
</script>
